import React from "react";
import BlogsLayout from "../sections/Blogs/BlogsLayout";
import Heading from "../components/common/Typography/Heading";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_BLOG_LISTING_TITLE_GAP_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const Blogs = () => {
  return (
    <>
      <div
        className={`tp-container-main mx-auto ${publicMainHeaderOffsetClass()}`}
      >
        <Heading variant={"h1"} className={"text-offblack text-center"}>
          Industry Insights & Trends
        </Heading>
        <div className={PUBLIC_BLOG_LISTING_TITLE_GAP_CLASS}>
          <BlogsLayout />
        </div>
      </div>
    </>
  );
};

export default Blogs;
